import React, { useEffect, useMemo, useState } from 'react'
import { BiSearch } from "react-icons/bi";
import classes from "./PricingNewpayment.module.css";
import modalClasses from "../../Pages/Dashboard/Components/DashboardHeader/DashboardHeader.module.css";
import promix from "../../Assets/Promix.svg"
import deletes from "../../Assets/delete.svg"
import credtcrd from "../../Assets/Credit Card.png"
import wallet from "../../Assets/wallet-03.png"
import card from "../../Assets/credit-card-01.png"
import lock from "../../Assets/lock.png"
import arrowleft from "../../Assets/arrow-left.png"
import marked from "../../Assets/tick.png"
import star from "../../Assets/star.svg"
import yesido from "../../Assets/yesido.png"
import setitup from "../../Assets/setitup.png"
import uploadIcon from "../../Assets/uploadicon.png"
import exitIcon from "../../Assets/exitIcon.svg"
import warningIconDash from "../../Assets/warningIconDash.svg"
import swal from 'sweetalert'
import { Button, Modal, Form, Spinner, Tab, Tabs, Row, Col, Popover } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import api, { withCompanyId } from "../../Components/API/Api";
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';

const ChartOfAccount = () => {
    const [showPaystackModal, setShowPaystackModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(true);
    const [showAcctModal, setShowAcctModal] = useState(false);
    
    // Modal states for setup flow
    const [showOpeningBalancesModal, setShowOpeningBalancesModal] = useState(false);
    const [showUploadModal, setShowUploadModal] = useState(false);
    const [uploadedFile, setUploadedFile] = useState(null);
    const [selectedAccount, setSelectedAccount] = useState('');
    const [loadingAccounts, setLoadingAccounts] = useState(false);
    const [submittingUpload, setSubmittingUpload] = useState(false);
    const [settingUpAccounts, setSettingUpAccounts] = useState(false);
    const [accountSettingStatus, setAccountSettingStatus] = useState(null);
    const [companyInfo, setCompanyInfo] = useState(null);
    
    const handleShowSuccessModal = () => setShowSuccessModal(true);
    const handleShowAcctModal = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };
    const handleCloseAcctModal = () => setShowAcctModal(false);
    const handleCloseSuccessModal = () => setShowSuccessModal(false);
    const [successSummary, setSuccessSummary] = useState(null);
    const [showDeclinedModal, setShowDeclinedModal] = useState(false);
    const [showAccountDetailsModal, setShowAccountDetailsModal] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState("paystack");
    const [savingAccountsLoading, setSavingAccountsLoading] = useState(false);
    // Dummy wallet account details
    const [accountDetails, setAccountDetails] = useState({ accountName: 'Demo User', accountNumber: '9876543210', bank: 'DemoBank' });
    // Dummy wallet balance (set to 0 for insufficient funds test)
    const [walletBalance, setWalletBalance] = useState(0);
    const location = useLocation();
    const navigate = useNavigate();
    const [rows, setRows] = useState([
        { accountName: "", accountCode: "", description: "", debit: "", credit: "", showDropdown: false }
    ]);
    const [accountTypes, setAccountTypes] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedFilter, setSelectedFilter] = useState('All Types');
    const [loadingTypes, setLoadingTypes] = useState(false);
    const [accountsLoading, setAccountsLoading] = useState(false);
    const [accounts, setAccounts] = useState([]);
    const { login, setActiveCompany } = useUser();
    const selectedPlan = location.state?.selectedPlan;
    const searchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);

    const searchTable = (e) => {
        setSearchTerm(e.target.value);
    }

    const formatMonthlyPrice = (plan) => {
        if (!plan || plan.monthly == null) return "₦0";
        const value = parseFloat(plan.monthly);
        if (Number.isNaN(value)) return "₦0";
        return `₦${value.toLocaleString("en-US", {
            minimumIntegerDigits: 1,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

      const removeRow = (index) => {
    setRows(prev => prev.length === 1 ? prev : prev.filter((_, i) => i !== index));
  };

//     const addLine = () => {
//     setRows(prev => [
//       ...prev,
//       { accountId: "", accountDisplay: "", description: "", debit: "", credit: "", showDropdown: false },
//     ]);
//   };

const addLine = () => {
  setRows(prev => [
    ...prev,
    {
      accountId: "",
      accountDisplay: "",
      description: "",
      debit: "",
      credit: "",
      showDropdown: false,
      isPrefilled: false, // 👈 user-added rows
    },
  ]);
};  




  const handleChange = (index, field, value) => {
    setRows(prev => {
      const newRows = [...prev];
      const row = { ...newRows[index] };
      if (field === "debit") {
        row.debit = value;
        if (parseFloat(value) > 0) row.credit = "0";
      } else if (field === "credit") {
        row.credit = value;
        if (parseFloat(value) > 0) row.debit = "0";
      } else if (field === "account") {
        row.accountId = value?.id ?? "";
        row.accountDisplay = `${value?.gl_code ?? value?.code ?? ""} - ${value?.gl_name ?? value?.name ?? ""}`;
      } else if (field === "showDropdown") {
        row.showDropdown = value;
      } else {
        row[field] = value;
      }
      newRows[index] = row;
      return newRows;
    });
  };

    const planName = selectedPlan?.name || "Professional";
    const planDescription = selectedPlan?.use || "For growing businesses and small teams";
    const planAmount = selectedPlan ? formatMonthlyPrice(selectedPlan) : "₦25,000";
    const planPrivileges = selectedPlan?.privileges || [
        "5 Users",
        "Advanced Reports",
        "Multi-currency",
        "API Access",
        "Priority Support",
        "Custom Integrations",
        "Automated Workflows",
    ];

    // Auto-open the modal on page load for new users
    useEffect(() => {
      setShowOpeningBalancesModal(true);
    }, []);

    // Fetch accounts when modal is about to be shown
    useEffect(() => {
      if (showUploadModal) {
        fetchAccountsForModal();
      }
    }, [showUploadModal]);

    const fetchAccountsForModal = async () => {
      setLoadingAccounts(true);
      try {
        const response = await api.get('/v1/get-sub-categories');
        const result = Array.isArray(response?.data?.data) ? response.data.data : [];
        setAccounts(result);
      } catch (error) {
        console.error('Error fetching accounts:', error);
        setAccounts([]);
      } finally {
        setLoadingAccounts(false);
      }
    };

    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (file) {
        setUploadedFile(file);
      }
    };

    const handleContinueUpload = async () => {
      if (!uploadedFile || !selectedAccount) {
        swal('Error', 'Please select both an account type and a file to upload.', 'error');
        return;
      }

      setSubmittingUpload(true);
      try {
        const companyId = localStorage.getItem('company_id');
        const formData = new FormData();
        formData.append('file', uploadedFile);
        formData.append('account_type', selectedAccount);
        formData.append('company_id', companyId);

        const response = await api.post('/v1/upload_account', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        swal('Success', response?.data?.message || 'Chart of accounts uploaded successfully!', 'success');

        const reader = new FileReader();
        reader.onload = () => {
          const fileData = {
            name: uploadedFile.name,
            type: uploadedFile.type,
            size: uploadedFile.size,
            data: reader.result,
          };

          const uuid = response?.data?.data?.uuid || response?.data?.uuid;
          console.log('Final UUID being passed:', uuid);

          setShowUploadModal(false);
          setShowOpeningBalancesModal(false);
          setUploadedFile(null);
          setSelectedAccount('');

          navigate('/accounting/chartofaccount-preview', {
            state: {
              files: [fileData],
              uuid: uuid,
            },
          });
        };
        reader.readAsDataURL(uploadedFile);
      } catch (error) {
        let errorMessage = 'An error occurred while uploading the file.';
        
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error?.response?.data?.error) {
          errorMessage = error.response.data.error;
        } else if (error?.message) {
          errorMessage = error.message;
        }

        swal('Upload Failed', errorMessage, 'error');
        console.error('Error uploading account file:', error);
      } finally {
        setSubmittingUpload(false);
      }
    };

    const handleAccountSettingSetup = async (type) => {
      setSettingUpAccounts(true);
      try {
        const companyId = localStorage.getItem('company_id');
        console.log('Calling account_setting endpoint with type:', type, 'company_id:', companyId);
        
        const response = await api.post('/v1/account_setting', {
          type: type.toString(),
          company_id: companyId
        });

        console.log('Account setting response:', response.data);
        
        if (type === 0) {
          setShowOpeningBalancesModal(false);
          setShowUploadModal(true);
        } else {
          swal('Success', response?.data?.message || 'Account setup initiated successfully!', 'success');
          setShowOpeningBalancesModal(false);
        }
      } catch (error) {
        console.error('Error setting up accounts:', error);
        let errorMessage = 'An error occurred while setting up accounts.';
        
        if (error?.response?.data?.message) {
          errorMessage = error.response.data.message;
        } else if (error?.response?.data?.error) {
          errorMessage = error.response.data.error;
        }

        swal('Setup Failed', errorMessage, 'error');
      } finally {
        setSettingUpAccounts(false);
      }
    };

    const handleDownloadTemplate = async () => {
      try {
        const response = await api.get('/v1/download-account-template', { responseType: 'blob' });
        const blob = new Blob([response.data]);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'chart-of-accounts-template.xlsx';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } catch (error) {
        console.error('Error downloading template:', error);
      }
    };

    const handleSkipSetup = () => {
      setShowOpeningBalancesModal(false);
      setShowUploadModal(false);
      setUploadedFile(null);
      setSelectedAccount('');
      navigate('/dashboard');
    };

      // Fetch accounts
      useEffect(() => {
        const fetchAccounts = async () => {
          // Try to get company_id and industryId from location state first, then localStorage
          let companyId = location.state?.company_id || localStorage.getItem("company_id") || localStorage.getItem("activeCompanyId");
          let industryId = location.state?.industryId || localStorage.getItem("industryId") || localStorage.getItem("selectedIndustryId");
          const token = localStorage.getItem("authToken");
          
          // Log for debugging
          console.log("Chart of Account - Checking auth context:", {
            token: token ? "Present" : "Missing",
            companyId: companyId ? companyId : "Missing",
            industryId: industryId ? industryId : "Missing",
            fromLocationState: !!location.state
          });
          
          if (!token || !companyId) {
            console.log("Token or Company ID not found, skipping fetch accounts");
            return;
          }
          
          setAccountsLoading(true);
          try {
            const res = await api.get('/v1/account/company-accounts');
            let raw = res?.data?.data ?? res?.data ?? [];
            if (Array.isArray(raw.data)) raw = raw.data;
            setAccounts(Array.isArray(raw) ? raw : []);
          } catch (err) {
            console.error("Error fetching accounts:", err);
            if (err.response?.status === 401) {
              console.error("Unauthorized - company_id might not be set correctly in headers");
              console.error("Current localStorage values:", {
                company_id: localStorage.getItem("company_id"),
                activeCompanyId: localStorage.getItem("activeCompanyId"),
                industryId: localStorage.getItem("industryId"),
                selectedIndustryId: localStorage.getItem("selectedIndustryId")
              });
            }
            setAccounts([]);
          } finally {
            setAccountsLoading(false);
          }
        };
        
        fetchAccounts();
    }, [location.state]);

        const token = localStorage.getItem("authToken");

        useEffect(() => {
            const fetchAccountTypes = async () => {
                try {
                    setLoadingTypes(true);

                    const resp = await api.get('/v1/get-sub-categories');

                    const raw = resp?.data?.data ?? resp?.data ?? [];
                    const list = Array.isArray(raw) ? raw : [];

                    setAccountTypes(list);
                } catch (e) {
                    console.error(
                        'Failed to load account types',
                        e?.response?.data || e?.message
                    );
                    setAccountTypes([]);
                } finally {
                    setLoadingTypes(false);
                }
            };

            fetchAccountTypes();
        }, [token]);      
    
      // Populate rows with accounts
    //   useEffect(() => {
    //     if (showAcctModal && accounts.length > 0) {
    //       setRows(accounts.map(acc => ({
    //         accountId: acc.id,
    //         accountName: acc.gl_name ?? acc.name ?? "",
    //         accountCode: acc.gl_code ?? acc.code ?? "",
    //         description: "",
    //         debit: "",
    //         credit: "",
    //         showDropdown: false
    //       })));
    //     }
    //   }, [showAcctModal, accounts]);

        useEffect(() => {
        if (accounts.length > 0) {
            setRows(
            accounts.map(acc => ({
                accountId: acc.id,
                accountName: acc.gl_name ?? acc.name ?? "",
                accountCode: acc.gl_code ?? acc.code ?? "",
                description: "",
                debit: "",
                credit: "",
                showDropdown: false,
                isPrefilled: true, // 👈 add this
            }))
            );
        }
        }, [accounts]);

    
        const saveNewAccountsOld = async () => {
        try {
            setSavingAccountsLoading(true);

            // get company_id
            const companyId =
            localStorage.getItem("company_id") ||
            localStorage.getItem("activeCompanyId");

            if (!companyId) {
            Swal.fire("Error", "Company ID not found", "error");
            return;
            }

            // only newly added rows
            const newRows = rows.filter((row) => !row.isPrefilled);

            // if (newRows.length === 0) {
            // Swal.fire("Info", "No new accounts to save", "info");
            // return;
            // }

            // validate rows
            const invalidRow = newRows.find(
            (row) => !row.accountName || !row.accountCode
            );

            if (invalidRow) {
            Swal.fire(
                "Validation Error",
                "All new rows must have account name and account type",
                "warning"
            );
            return;
            }

            // format payload
            const payload = {
            account_type: newRows.map((row) => row.accountCode),
            account_name: newRows.map((row) => row.accountName),
            company_id: companyId,
            };

            console.log("Payload:", payload);

            const response = await api.post(
            "/v1/create-account-array",
            payload
            );

            if (
            response?.data?.status === true ||
            response?.data?.success === true
            ) {
            Swal.fire(
                "Success",
                "Accounts created successfully",
                "success"
            );

            navigate("/upload-opening-bal");

            } else {
            Swal.fire(
                "Error",
                response?.data?.message || "Failed to save accounts",
                "error"
            );
            }
        } catch (error) {
            console.error(error);

            Swal.fire(
            "Error",
            error?.response?.data?.message ||
                "Something went wrong",
            "error"
            );
        } finally {
            setSavingAccountsLoading(false);
        }
        };

        const saveNewAccounts = async () => {
            try {
                setSavingAccountsLoading(true);

                const companyId =
                    localStorage.getItem("company_id") ||
                    localStorage.getItem("activeCompanyId");

                if (!companyId) {
                    Swal.fire("Error", "Company ID not found", "error");
                    return;
                }

                // only newly added rows
                const newRows = rows.filter((row) => !row.isPrefilled);

                // if no new rows, just navigate
                if (newRows.length === 0) {
                    navigate("/upload-opening-bal");
                    return;
                }

                // validate rows
                const invalidRow = newRows.find(
                    (row) => !row.accountName || !row.accountCode
                );

                if (invalidRow) {
                    Swal.fire(
                        "Validation Error",
                        "All new rows must have account name and account type",
                        "warning"
                    );
                    return;
                }

                // format payload
                const payload = {
                    account_type: newRows.map((row) => row.accountCode),
                    account_name: newRows.map((row) => row.accountName),
                    company_id: companyId,
                };

                console.log("Payload:", payload);

                const response = await api.post(
                    "/v1/create-account-array",
                    payload
                );

                if (
                    response?.data?.status === true ||
                    response?.data?.success === true
                ) {
                    Swal.fire(
                        "Success",
                        "Accounts created successfully",
                        "success"
                    );

                    navigate("/upload-opening-bal");
                } else {
                    Swal.fire(
                        "Error",
                        response?.data?.message || "Failed to save accounts",
                        "error"
                    );
                }
            } catch (error) {
                console.error(error);

                Swal.fire(
                    "Error",
                    error?.response?.data?.message ||
                        "Something went wrong",
                    "error"
                );
            } finally {
                setSavingAccountsLoading(false);
            }
        };
    

    // Ensure page is scrolled to top whenever this route is navigated to
    useEffect(() => {
        try {
            window.scrollTo(0, 0);
        } catch {
            // ignore if environment doesn't support window scrolling
        }
    }, [location.pathname]);

    // If Paystack redirects back after checkout, show the appropriate modal.
    useEffect(() => {
        // Merge search params and hash params (some gateways use hash fragments)
        const combined = new URLSearchParams(location.search || "");
        if (location.hash) {
            const hashString = location.hash.replace(/^#/, "");
            const hashParams = new URLSearchParams(hashString);
            for (const [k, v] of hashParams.entries()) {
                if (!combined.has(k)) combined.set(k, v);
            }
        }

        const status = (combined.get("status") || combined.get("payment_status") || "").toLowerCase();
        const successFlag = (combined.get("success") || combined.get("paid") || "").toLowerCase();
        const failedFlag = (combined.get("failed") || combined.get("cancelled") || "").toLowerCase();

        const isSuccessFromRedirect =
            status === "success" ||
            status === "successful" ||
            successFlag === "true" ||
            successFlag === "1" ||
            successFlag === "yes";

        const isFailedFromRedirect =
            status === "failed" ||
            status === "failure" ||
            status === "cancelled" ||
            status === "canceled" ||
            failedFlag === "true" ||
            failedFlag === "1" ||
            failedFlag === "yes";

        const referenceParam = combined.get("reference") || combined.get("trxref") || combined.get("tx_ref") || "";
        const treatReferenceAsSuccess = referenceParam && !isFailedFromRedirect;

        // Debug helpers to help during testing
        try {
            console.debug("Payment redirect params:", Object.fromEntries(combined.entries()));
        } catch {}

        if (isSuccessFromRedirect || treatReferenceAsSuccess) {
            console.log("Token after redirect:", localStorage.getItem("token"));
            let foundSummary = null;
            try {
                const raw = localStorage.getItem("pendingPaymentSummary");
                if (raw) foundSummary = JSON.parse(raw);
            } catch (err) {
                console.debug("Failed to read pendingPaymentSummary:", err);
            } finally {
                localStorage.removeItem("pendingPaymentSummary");
            }

            // Prefer explicit display values returned by the backend in query
            // params (so we can show a full summary even if localStorage was
            // cleared). Common keys: `plan`, `plan_name`, `amount`, `amountPaid`.
            const planFromQuery = combined.get('plan') || combined.get('plan_name') || '';
            const amountFromQuery = combined.get('amount') || combined.get('amountPaid') || combined.get('amount_paid') || '';

            const formatAmount = (val) => {
                if (!val) return planAmount;
                const n = Number(String(val).replace(/[^0-9.-]+/g, ''));
                if (Number.isFinite(n)) {
                    const naira = n / 100; // Convert from kobo to naira
                    return `₦${naira.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                }
                return String(val);
            };

            if (!foundSummary) {
                foundSummary = {
                    plan: planFromQuery || selectedPlan?.name || planName,
                    amountPaid: formatAmount(amountFromQuery) || planAmount,
                    billing: combined.get('billing') || 'Monthly',
                };
            } else {
                // If a saved summary exists but backend provided nicer display
                // values, prefer those.
                if (planFromQuery) foundSummary.plan = planFromQuery;
                if (amountFromQuery) foundSummary.amountPaid = formatAmount(amountFromQuery);
                if (combined.get('billing')) foundSummary.billing = combined.get('billing');
            }

            setSuccessSummary(foundSummary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
        } else if (isFailedFromRedirect) {
            localStorage.removeItem("pendingPaymentSummary");
            setShowDeclinedModal(true);
        }
    }, [location.search, location.hash]);

    // Load user's auto-generated wallet account details from localStorage
    // Dummy data: skip loading from localStorage for now
    // useEffect(() => {
    //     ...existing code...
    // }, []);

    // Function to auto-login user after successful payment
    const autoLoginUser = async ({ redirectToDashboard } = { redirectToDashboard: false }) => {
        try {
            const userEmail = localStorage.getItem("userEmail");
            const userPassword = localStorage.getItem("userPassword");

            if (!userEmail || !userPassword) {
                console.warn("User credentials not found in localStorage for auto-login");
                return;
            }

            const response = await axios.post(`${BASE_URL}/v1/login`, {
                email: userEmail,
                password: userPassword,
            });

            if (response.data?.status === true || response.data?.success === true) {
                const token = response.data?.data?.token || response.data?.token;
                const userData = response.data?.data?.user || response.data?.user;

                if (token && userData) {
                    // Use the login function from UserContext
                    login(userData, token);

                    // Fetch companies and pick one so dashboard requests have company_id
                    try {
                        // Clear any previous company data to avoid conflicts
                        // localStorage.removeItem('company_id');
                        // localStorage.removeItem('activeCompanyId');
                        // localStorage.removeItem('companyInfo');
                        // localStorage.removeItem('companies');
                        // delete axios.defaults.headers.common['company_id'];

                        const compRes = await axios.get(`${BASE_URL}/v1/companies/get-info`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                Accept: "application/json",
                            },
                        });
                        const list = Array.isArray(compRes?.data?.data)
                            ? compRes.data.data
                            : (compRes?.data?.data ? [compRes.data.data] : []);
                        try { localStorage.setItem('companies', JSON.stringify(list)); } catch {}

                        const first = list?.[0] || null;
                        const cid = first?.company_id || first?.id || first?.companyId || null;
                        if (cid && typeof setActiveCompany === 'function') {
                            setActiveCompany(String(cid), first);
                        } else if (cid) {
                            try { localStorage.setItem('company_id', String(cid)); } catch {}
                            try { localStorage.setItem('activeCompanyId', String(cid)); } catch {}
                            try { localStorage.setItem('companyInfo', JSON.stringify(first)); } catch {}
                            try { axios.defaults.headers.common['company_id'] = String(cid); } catch {}
                        }
                    } catch (e) {
                        // If this fails, user is still logged in; dashboard may still work depending on endpoints.
                        console.warn("Failed to fetch/set company after auto-login:", e);
                    }

                    // Clear stored credentials (we only needed them for one-time auto-login)
                    try {
                        localStorage.removeItem("userPassword");
                        localStorage.removeItem("userEmail");
                        localStorage.removeItem("userNIN");
                    } catch {}

                    console.log("User auto-logged in after payment");
                    if (redirectToDashboard) {
                        navigate("/dashboard", { replace: true });
                    }
                } else {
                    console.warn("Login response missing token or user data");
                }
            } else {
                console.warn("Auto-login failed:", response.data?.message);
            }
        } catch (error) {
            console.error("Error during auto-login:", error);
        }
    };

    const handleShowFunction = () => {
    setShowAcctModal(true);
    setShowSuccessModal(false);
    };




    const handlePaystackClick = async (e) => {
        e.preventDefault();

        if (paymentMethod === "wallet") {
            // Handle wallet payment
            const amountToPay = parseFloat(planAmount.replace(/[^0-9.-]+/g, ''));
            if (isNaN(amountToPay)) {
                Swal.fire("Error", "Invalid plan amount.", "error");
                return;
            }

            if (walletBalance < amountToPay) {
                Swal.fire("Insufficient Balance", "Your wallet balance is not enough to complete this payment.", "error");
                return;
            }

            // Deduct from wallet
            const newBalance = walletBalance - amountToPay;
            setWalletBalance(newBalance);
            localStorage.setItem("walletBalance", newBalance.toString());

            // Set success summary
            const summary = {
                plan: selectedPlan?.name || planName,
                amountPaid: planAmount,
                billing: "Monthly",
            };
            setSuccessSummary(summary);

            try {
                localStorage.setItem("hasPaidPlan", "true");
            } catch {}

            // setShowSuccessModal(true);
            handleShowSuccessModal();
            // Auto-login the user after successful payment
            void autoLoginUser({ redirectToDashboard: true });
            return;
        }

        // Ensure Paystack is selected as the payment method
        if (paymentMethod !== "paystack") {
            Swal.fire("Payment Method", "Please select 'Pay with Paystack' to continue.", "warning");
            return;
        }

        // Try multiple token sources: authToken, token, or from location state
        const token = 
            localStorage.getItem("authToken") || 
            localStorage.getItem("token") ||
            location.state?.token;
        
        if (!token) {
            console.error("Authentication token not found. Available localStorage keys:", Object.keys(localStorage));
            Swal.fire("Not Logged In", "You must be logged in to make a payment. Please complete company registration first.", "error");
            return;
        }
        
        console.log("Using token for payment authentication");

        // Show processing modal immediately
        setShowPaystackModal(true);
        const startTime = Date.now();

        try {
            const payload = {
                plan_id: selectedPlan?.id,
                plan_name: selectedPlan?.name,
            };

            const res = await axios.post(`${BASE_URL}/v1/pay-package`, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            });

            const data = res?.data || {};
            const isSuccess = data?.status === true || data?.success === true;
            const backendMessage =
                (typeof data?.message === "string" && data.message) ||
                (typeof data?.msg === "string" && data.msg) ||
                "";
            const checkoutUrl = typeof data?.data === "string" ? data.data : "";

            const minProcessingTime = 2000; // 2s
            const elapsed = Date.now() - startTime;
            if (elapsed < minProcessingTime) {
                await new Promise((resolve) => setTimeout(resolve, minProcessingTime - elapsed));
            }

            if (isSuccess) {
                if (!checkoutUrl) {
                    setShowPaystackModal(false);
                    await Swal.fire(
                        "Payment Initialization Failed",
                        backendMessage || "No checkout link was returned. Please try again.",
                        "error"
                    );
                    return;
                }

                // Persist summary so we can show it after Paystack redirects back.
                try {
                    localStorage.setItem(
                        "pendingPaymentSummary",
                        JSON.stringify({
                            plan: selectedPlan?.name || planName,
                            amountPaid: planAmount,
                            billing: "Monthly",
                        })
                    );
                } catch {
                    // ignore
                }

                // Redirect user to Paystack checkout.
                window.location.assign(checkoutUrl);
            } else {
                setShowPaystackModal(false);
                await Swal.fire(
                    "Payment Failed",
                    backendMessage || "Payment could not be completed. Please try again.",
                    "error"
                );
            }
        } catch (error) {
            console.error("Error initiating Paystack package payment:", error);
            const errMsg =
                error?.response?.data?.message ||
                error?.response?.data?.msg ||
                error?.message ||
                "Failed to initiate payment. Please try again.";
            await Swal.fire("Error", errMsg, "error");
        } finally {
            // Ensure processing modal is closed in case of early failures
            setShowPaystackModal(false);
        }
    };

    return (
        <div>
            <div className={classes.vitchri}>
                <div>
                    <img src={promix} />
                </div>

                <div className={classes.busy}>
                    <p className={classes.gate}>Features</p>
                    <p className={classes.gate}>Pricing</p>
                    <p className={classes.gate}>Resources</p>

                    <button className={classes.bu_tton}>Start Free Trial</button>
                </div>
            </div>

            <div className={classes.pirates}>
           Set up your chart of accounts
            </div>

            <p className={classes.ship}>We’ve created a starting structure tailored to your industry. Feel free to <br/> review, edit, or add accounts</p>

            <div style={{ padding: '10px', maxWidth: '900px', margin: '0 auto' }}>
                
                    <Form>
                        <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", padding: 10}}>
                            <Form.Select
                                value={selectedFilter}
                                onChange={(e) => setSelectedFilter(e.target.value)}
                                className={classes.dropdown}
                            >
                                <option value=''>All Types</option>
                                <option value='accountname'>Account Name</option>
                                <option value='accountcode'>Account Code</option>
                            </Form.Select>
                        
                                                
                            <div className={classes.searchWrapper}>
                                <BiSearch className={classes.searchIcon} size={20} />
                                <Form.Control
                                type="search"
                                value={searchTerm}
                                onChange={searchTable}
                                placeholder="Search..."
                                className={classes.searchInput}
                                />        
                            </div>
                        </div>
                    </Form>

                <div style={{ padding: '10px'}}>
                    {/* <h2 style={{ marginBottom: '30px', fontSize: '24px', fontWeight: 'bold' }}>
                        Chart of Account Setup
                    </h2> */}
                    
                <Form className={classes.compactForm}>
                    <div className={classes.tableScrollWrapper}>
                        <table className={classes.tableChartOfAccount}>
                            <thead>
                                <tr>
                                <th>#</th>
                                <th>Account Name</th>
                                <th>Account Code/Type</th>
                                <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {accountsLoading ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center", padding: "40px" }}>
                                    <div className={classes.spinnerWrapper}><div className={classes.spinner}></div></div>
                                    </td>
                                </tr>
                                ) : rows.length === 0 ? (
                                <tr>
                                    <td colSpan="6" style={{ textAlign: "center", padding: "20px", color: "#888" }}>
                                    No rows available.
                                    </td>
                                </tr>
                                ) : (
                                rows.map((row, index) => (
                                    <tr key={index}>
                                    <td style={{fontSize:"13px"}} >{index + 1}</td>
                                    <td>
                                        <input
                                        type="text"
                                        className={classes.debitInput}
                                        value={row.accountName}
                                        onChange={(e) => handleChange(index, "accountName", e.target.value)}
                                        placeholder="Enter Account Name"
                                        disabled={row.isPrefilled}
                                        // disabled={row.accountName && parseFloat(row.accountName) > 0}
                                        />
                                    </td>
                                    <td>
                                    {row.isPrefilled ? (
                                    <input
                                        type="text"
                                        className={classes.debitInput}
                                        value={row.accountCode}
                                        onChange={(e) => handleChange(index, "accountCode", e.target.value)}
                                        // placeholder="0.00"
                                        disabled={row.isPrefilled}
                                        />
                                    ) : (
                                    <select
                                        id="accountType"
                                        className={classes.formSelect}
                                        value={row.accountCode}
                                        onChange={(e) => handleChange(index, "accountCode", e.target.value)}
                                        disabled={row.isPrefilled}
                                    >
                                        <option value="" disabled>{loadingTypes ? 'Loading types...' : 'Select Account type'}</option>
                                        {accountTypes.map((t, idx) => {
                                            const value = t?.id ?? t?.value ?? t?.code ?? t?.description ?? t?.label ?? `${idx}`;
                                            const label = t?.description ?? t?.label ?? t?.title ?? t?.displayName ?? String(value);
                                            return (
                                                <option key={value} value={value}>{label}</option>
                                            );
                                        })}
                                    </select>
                                    )}
                                    </td>
                                    <td>
                                        <img
                                        src={deletes}
                                        alt="Delete"
                                        onClick={() => !row.isPrefilled && removeRow(index)}
                                        style={{
                                            cursor: row.isPrefilled ? "not-allowed" : "pointer",
                                            width: "30%",
                                            height: "40px",
                                            opacity: row.isPrefilled ? 0.5 : 1
                                        }}
                                        />
                                        {/* <button  className={classes.removeBtn}>Remove</button> */}
                                    </td>
                                    </tr>
                                ))
                                )}
                            </tbody>

                        </table>
                    </div>
                </Form>
                <div style={{display: "flex", justifyContent: "space-between", alignItems: "center", margin: 20}}>
                    <button
                        className={classes.customAddBtn}
                        onClick={addLine}
                        // style={{ marginTop: '20px' }}
                    >
                        + Add Account
                    </button>
                     <button
                        className={classes.customSaveBtnChart}
                        onClick={saveNewAccounts}
                        disabled={savingAccountsLoading}
                    >
                        {savingAccountsLoading ? "Processing..." : "Continue"}
                    </button>
                </div>

                <div style={{ marginTop: '10px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                    {/* <button
                        className={classes.customCancelBtn}
                        onClick={() => navigate("/dashboard")}
                    >
                        Cancel
                    </button> */}
                    {/* <button
                        className={classes.customSaveBtn}
                        onClick={saveNewAccounts}
                        disabled={savingAccountsLoading}
                    >
                        {savingAccountsLoading ? "Processing..." : "Continue"}
                    </button> */}
                </div>
                 <p className={classes.proeterw}>Not ready yet? You can skip this step and complete your chart of accounts anytime from your dashboard</p>
                </div>

               
            </div>

            {showDeclinedModal && (
                <div className={classes.paystack_overlay}>
                    <div className={classes.declined_modal}>
                        <div className={classes.declined_badge_wrap} aria-hidden="true">
                            <div className={classes.declined_badge}>
                                <div className={classes.declined_icon} />
                            </div>
                        </div>

                        <p className={classes.declined_title}>Payment Not Completed</p>
                        <p className={classes.declined_subtitle}>
                            No charges were made to your account<br />
                            You can try again or choose a different payment method
                        </p>

                        <div className={classes.declined_actions}>
                            <button
                                className={classes.declined_primary}
                                onClick={() => {
                                    setShowDeclinedModal(false);
                                    setPaymentMethod("");
                                }}
                            >
                                Change payment method
                            </button>
                            <button
                                className={classes.declined_secondary}
                                onClick={() => {
                                    setShowDeclinedModal(false);
                                    // Remove query params so the user can retry cleanly.
                                    navigate(location.pathname, { replace: true });
                                }}
                            >
                                Try Again
                            </button>
                        </div>

                        <p className={classes.declined_footer}>
                            If you were debited, please contact our support team for assistance<br />
                            <span
                                className={classes.declined_support_link}
                                onClick={() => window.open("mailto:support@promix.com", "_blank")}
                            >
                            Contact Support
                            </span>
                        </p>
                    </div>
                </div>
            )}

            {showAccountDetailsModal && (
                <div className={classes.paystack_overlay}>
                    <div className={classes.success_modal} style={{maxWidth: '400px'}}>
                        <p className={classes.success_title}>Account Details</p>
                        <p className={classes.success_subtitle}>Use these details to fund your wallet via bank transfer</p>

                        <div style={{border: '1px solid #ddd', padding: '15px', borderRadius: '5px', backgroundColor: '#f9f9f9', margin: '20px 0'}}>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Account Name:</strong> {accountDetails.accountName}</p>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Account Number:</strong> {accountDetails.accountNumber}</p>
                            <p style={{fontSize: '14px', margin: '5px 0'}}><strong>Bank:</strong> {accountDetails.bank}</p>
                        </div>

                        <div style={{margin: '20px 0px 0px 0px ', textAlign: 'center'}}>
                            <p style={{fontSize: '14px'}}>I have funded wallet</p>
                        </div>

                        <button className={classes.declined_primary} onClick={() => setShowAccountDetailsModal(false)}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* <p className={classes.proeterw}>Trusted by 10,000+ businesses worldwide</p>
            <div className={classes.pitfall}>
                <div className={classes.number_num}>
                    <p className={classes.costat}>₦50B+</p>
                    <p className={classes.prethelr}>Processed Monthly</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>99.9%</p>
                    <p className={classes.prethelr}> Uptime SLA</p>
                </div>
                <div className={classes.number_num}>
                    <p className={classes.costat}>500+</p>
                    <p className={classes.prethelr}>Integrations</p>
                </div>
            </div> */}

            {showOpeningBalancesModal && (
              <div className={modalClasses.modalOverlay}>
                <div className={modalClasses.modalContent}>
                  <div className={modalClasses.modalHeadertxt}>
                    <h2 className={modalClasses.modalTitle}>Do you have an existing chart of accounts?</h2>
                    <p className={modalClasses.modalDescription}>
                      A chart of accounts organises your financial transactions into categories. Let us know how you'd like to proceed so we can get you set up.
                    </p>
                  </div>

                  <div className={modalClasses.optionsContainer}>
                    <div className={modalClasses.optionCard} onClick={() => handleAccountSettingSetup(0)} style={{ opacity: settingUpAccounts ? 0.6 : 1, pointerEvents: settingUpAccounts ? 'none' : 'auto', cursor: settingUpAccounts ? 'not-allowed' : 'pointer' }}>
                      <div className={modalClasses.optionIcon}>
                        <span>
                          <img src={yesido} style={{ width: 52, height: 52 }} />
                        </span>
                      </div>
                      <h3>Yes I have one</h3>
                      <p>I'll upload my existing chart of accounts as an exisiting file</p>
                    </div>

                    <div className={modalClasses.optionCard} onClick={() => handleAccountSettingSetup(1)} style={{ opacity: settingUpAccounts ? 0.6 : 1, pointerEvents: settingUpAccounts ? 'none' : 'auto', cursor: settingUpAccounts ? 'not-allowed' : 'pointer' }}>
                      <div className={modalClasses.optionIcon}>
                        <span>
                          <img src={setitup} style={{ width: 52, height: 52 }} />
                        </span>
                      </div>
                      <h3>Set it up for me</h3>
                      <p>Create a default charts of accounts based on selected industry</p>
                    </div>
                  </div>

                  <div style={{ textAlign: 'center', marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #e2e8f0' }}>
                    <button
                      onClick={handleSkipSetup}
                      style={{
                        background: 'none',
                        border: 'none',
                        color: '#64748b',
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontFamily: 'Sora',
                        textDecoration: 'underline',
                        padding: '10px'
                      }}
                    >
                      Skip for now
                    </button>
                  </div>
                </div>
              </div>
            )}

            {showUploadModal && (
              <div className={modalClasses.modalOverlay}>
                <div className={modalClasses.uploadModalContent}>
                  <div className={modalClasses.uploadModalHeader}>
                    <h2 className={modalClasses.uploadModalTitle}>Upload your Chart of Accounts</h2>
                    <button
                      className={modalClasses.closeButton}
                      onClick={() => {
                        setShowUploadModal(false);
                        setUploadedFile(null);
                      }}
                    >
                      ✕
                    </button>
                  </div>

                  <p className={modalClasses.uploadDescription}>
                    Upload an Excel file (.xlsx or .xls) containing your existing accounts.<br />
                    We'll map the columns automatically
                  </p>

                  <div className={modalClasses.templateDownloadSection}>
                    <p className={modalClasses.templateText}>
                      Download the <span className={modalClasses.downloadLink} onClick={handleDownloadTemplate}>Charts of Account Template Here</span> Fill in your accounts per type — account code and account name required for each entry
                    </p>
                  </div>

                  <div className={modalClasses.accountSelectSection}>
                    <select
                      id="accountSelect"
                      className={modalClasses.accountSelect}
                      value={selectedAccount}
                      onChange={(e) => setSelectedAccount(e.target.value)}
                      disabled={loadingAccounts}
                    >
                      <option value="">
                        {loadingAccounts ? 'Loading accounts...' : 'Select account type'}
                      </option>
                      {Array.isArray(accounts) && accounts.map((account) => (
                        <option key={account.id} value={account.id}>
                          {account.description}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className={modalClasses.fileUploadContainer}>
                    <input
                      type="file"
                      id="fileInput"
                      accept=".xlsx,.xls,.csv"
                      onChange={handleFileUpload}
                      className={modalClasses.fileInput}
                    />
                    <label htmlFor="fileInput" className={modalClasses.fileUploadArea}>
                      <div className={modalClasses.fileUploadContent}>
                        <div className={modalClasses.uploadIcon}>
                          <img src={uploadIcon} alt="Upload" style={{ width: 72, height: 72 }} />
                        </div>
                        <p className={modalClasses.uploadText}>Click to upload or drag and drop</p>
                      </div>
                      <p className={modalClasses.fileTypes}>.xlsx, .xls, .csv accepted</p>
                    </label>
                    {uploadedFile && (
                      <div className={modalClasses.uploadedFileInfo}>
                        <p className={modalClasses.fileName}>✓ {uploadedFile.name}</p>
                      </div>
                    )}
                  </div>

                  <div className={modalClasses.uploadButtonsContainer}>
                    <button
                      className={modalClasses.backButton}
                      onClick={() => {
                        setShowUploadModal(false);
                        setUploadedFile(null);
                        setShowOpeningBalancesModal(true);
                      }}
                    >
                      Back
                    </button>
                    <button
                      className={modalClasses.continueButton}
                      onClick={handleContinueUpload}
                      disabled={!uploadedFile || !selectedAccount || submittingUpload}
                    >
                      {submittingUpload ? 'Uploading...' : 'Continue'}
                    </button>
                  </div>
                </div>
              </div>
            )}
        </div>

    )
}

export default ChartOfAccount;
